const STYLE_ID = 'xp-grid-col-editor-styles';

const PREFIX_STRIP = ['id_dt_', 'id_dl_', 'id_z_', 'id_d_', 'id_'];

export default class GridColumnEditor {
    constructor(opts) {
        this.listEl = opts.listEl;
        this.addBtnEl = opts.addBtnEl;
        this.getResource = opts.getResource;
        this.getFields = opts.getFields;
        this.fieldTextField = opts.fieldTextField || 'Name';
        this.fieldValueField = opts.fieldValueField || 'Name';
        this.onChange = typeof opts.onChange === 'function' ? opts.onChange : null;

        GridColumnEditor.ensureStyles();

        if (this.addBtnEl) {
            this.addBtnEl.onclick = () => this._addCard(null);
        }
    }

    setColumns(columns) {
        let cols = (columns && Array.isArray(columns)) ? columns : [];
        if (cols.length === 0) cols = [{ field: null, label: '' }];
        if (this.listEl) this.listEl.textContent = '';
        cols.forEach(c => this._addCard(c));
    }

    getColumns() {
        let result = [];
        if (!this.listEl) return result;
        this.listEl.querySelectorAll('.xp-grid-col-card').forEach(card => {
            let combo = card._fieldCombo;
            let field = combo ? combo.value() : null;
            if (!field) return;
            let labelInput = card._labelInput;
            let widthInput = card._widthInput;
            let alignSelect = card._alignSelect;
            let formatSelect = card._formatSelect;
            let condSelect = card._condSelect;
            let totalsSelect = card._totalsSelect;
            let widthVal = widthInput && widthInput.value ? parseInt(widthInput.value, 10) : null;

            let condKind = (condSelect && condSelect.value) || 'none';
            let minRaw = card._condMinInput && card._condMinInput.value;
            let maxRaw = card._condMaxInput && card._condMaxInput.value;
            let cond = { kind: condKind };
            if (minRaw !== '' && minRaw != null && !isNaN(Number(minRaw))) cond.min = Number(minRaw);
            if (maxRaw !== '' && maxRaw != null && !isNaN(Number(maxRaw))) cond.max = Number(maxRaw);
            if (condKind === 'dataBar' && card._barColorSelect) cond.barColor = card._barColorSelect.value;
            if (condKind === 'colorScale' && card._paletteSelect) cond.palette = card._paletteSelect.value;
            if (condKind === 'iconSet' && card._iconSetSelect) cond.iconSet = card._iconSetSelect.value;

            result.push({
                field: field,
                label: (labelInput && labelInput.value) || field,
                width: widthVal && widthVal > 0 ? widthVal : null,
                align: (alignSelect && alignSelect.value) || 'auto',
                format: { kind: (formatSelect && formatSelect.value) || 'auto' },
                cond: cond,
                totals: (totalsSelect && totalsSelect.value) || 'none'
            });
        });
        return result;
    }

    _addCard(col) {
        if (!this.listEl) return;
        let R = this.getResource;

        let card = document.createElement('div');
        card.className = 'xp-grid-col-card';
        card.draggable = true;

        let main = document.createElement('div');
        main.className = 'xp-grid-col-main';

        let handle = document.createElement('span');
        handle.className = 'xp-grid-col-handle';
        handle.title = R('DragToReorder');
        handle.textContent = '⋮⋮';

        let fieldWrap = document.createElement('div');
        fieldWrap.className = 'xp-grid-col-field-wrap';
        let fieldInput = document.createElement('input');
        fieldInput.className = 'xp-grid-col-field form-control';
        fieldWrap.appendChild(fieldInput);

        let labelInput = document.createElement('input');
        labelInput.type = 'text';
        labelInput.className = 'xp-grid-col-label form-control';
        labelInput.placeholder = R('GridChartColumnLabel');
        if (col && col.label) labelInput.value = col.label;
        labelInput.addEventListener('change', () => this._fire());

        let removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'xp-grid-col-remove';
        removeBtn.textContent = '×';
        removeBtn.title = R('Remove');
        removeBtn.addEventListener('click', () => { card.remove(); this._fire(); });

        main.appendChild(handle);
        main.appendChild(fieldWrap);
        main.appendChild(labelInput);
        main.appendChild(removeBtn);
        card.appendChild(main);

        let detail = document.createElement('div');
        detail.className = 'xp-grid-col-detail';

        let widthGroup = this._buildGroup(R('GridChartColumnWidth'));
        let widthInput = document.createElement('input');
        widthInput.type = 'number';
        widthInput.min = '0';
        widthInput.className = 'xp-grid-col-width form-control';
        widthInput.placeholder = R('Auto');
        if (col && col.width) widthInput.value = col.width;
        widthInput.addEventListener('change', () => this._fire());
        widthGroup.appendChild(widthInput);

        let alignGroup = this._buildGroup(R('GridChartColumnAlign'));
        let alignSelect = this._buildSelect('xp-grid-col-align', [
            ['auto', 'Auto'], ['left', 'Left'], ['center', 'Center'], ['right', 'Right']
        ]);
        alignSelect.value = (col && col.align) || 'auto';
        alignSelect.addEventListener('change', () => this._fire());
        alignGroup.appendChild(alignSelect);

        let formatGroup = this._buildGroup(R('GridChartColumnFormat'));
        let formatSelect = this._buildSelect('xp-grid-col-format', [
            ['auto', 'Auto'],
            ['number', 'GridChartFormatNumber'],
            ['percent', 'GridChartFormatPercent'],
            ['date', 'GridChartFormatDate'],
            ['text', 'GridChartFormatText'],
            ['sparkline', 'GridChartFormatSparkline']
        ]);
        formatSelect.value = (col && col.format && col.format.kind) || 'auto';
        formatSelect.addEventListener('change', () => this._fire());
        formatGroup.appendChild(formatSelect);

        let condGroup = this._buildGroup(R('GridChartColumnConditional'));
        let condSelect = this._buildSelect('xp-grid-col-cond', [
            ['none', 'GridChartCondNone'],
            ['dataBar', 'GridChartCondDataBar'],
            ['colorScale', 'GridChartCondColorScale'],
            ['iconSet', 'GridChartCondIconSet']
        ]);
        condSelect.value = (col && col.cond && col.cond.kind) || 'none';
        condGroup.appendChild(condSelect);

        let totalsGroup = this._buildGroup(R('GridChartColumnTotals'));
        let totalsSelect = this._buildSelect('xp-grid-col-totals', [
            ['none', 'GridChartTotalsNone'],
            ['sum', 'GridChartTotalsSum'],
            ['avg', 'GridChartTotalsAvg'],
            ['count', 'GridChartTotalsCount'],
            ['min', 'GridChartTotalsMin'],
            ['max', 'GridChartTotalsMax']
        ]);
        totalsSelect.value = (col && col.totals) || 'none';
        totalsSelect.addEventListener('change', () => this._fire());
        totalsGroup.appendChild(totalsSelect);

        detail.appendChild(widthGroup);
        detail.appendChild(alignGroup);
        detail.appendChild(formatGroup);
        detail.appendChild(condGroup);
        detail.appendChild(totalsGroup);
        card.appendChild(detail);

        let condOptions = document.createElement('div');
        condOptions.className = 'xp-grid-col-cond-options';

        let minGroup = this._buildGroup(R('GridChartCondMin'));
        let minInput = document.createElement('input');
        minInput.type = 'number';
        minInput.className = 'xp-grid-col-cond-min form-control';
        minInput.placeholder = R('Auto');
        if (col && col.cond && col.cond.min != null) minInput.value = col.cond.min;
        minInput.addEventListener('change', () => this._fire());
        minGroup.appendChild(minInput);

        let maxGroup = this._buildGroup(R('GridChartCondMax'));
        let maxInput = document.createElement('input');
        maxInput.type = 'number';
        maxInput.className = 'xp-grid-col-cond-max form-control';
        maxInput.placeholder = R('Auto');
        if (col && col.cond && col.cond.max != null) maxInput.value = col.cond.max;
        maxInput.addEventListener('change', () => this._fire());
        maxGroup.appendChild(maxInput);

        let barColorGroup = this._buildGroup(R('GridChartCondBarColor'));
        barColorGroup.dataset.kind = 'dataBar';
        let barColorSelect = this._buildSelect('xp-grid-col-barcolor', [
            ['theme', 'GridChartBarColorTheme'],
            ['green', 'GridChartBarColorGreen'],
            ['blue', 'GridChartBarColorBlue']
        ]);
        barColorSelect.value = (col && col.cond && col.cond.barColor) || 'theme';
        barColorSelect.addEventListener('change', () => this._fire());
        barColorGroup.appendChild(barColorSelect);

        let paletteGroup = this._buildGroup(R('GridChartCondPalette'));
        paletteGroup.dataset.kind = 'colorScale';
        let paletteSelect = this._buildSelect('xp-grid-col-palette', [
            ['theme', 'GridChartPaletteTheme'],
            ['redGreen', 'GridChartPaletteRedGreen'],
            ['mono', 'GridChartPaletteMono']
        ]);
        paletteSelect.value = (col && col.cond && col.cond.palette) || 'theme';
        paletteSelect.addEventListener('change', () => this._fire());
        paletteGroup.appendChild(paletteSelect);

        let iconSetGroup = this._buildGroup(R('GridChartCondIconSetOpt'));
        iconSetGroup.dataset.kind = 'iconSet';
        let iconSetSelect = this._buildSelect('xp-grid-col-iconset', [
            ['traffic', 'GridChartIconTraffic'],
            ['arrows', 'GridChartIconArrows'],
            ['check', 'GridChartIconCheck']
        ]);
        iconSetSelect.value = (col && col.cond && col.cond.iconSet) || 'traffic';
        iconSetSelect.addEventListener('change', () => this._fire());
        iconSetGroup.appendChild(iconSetSelect);

        condOptions.appendChild(minGroup);
        condOptions.appendChild(maxGroup);
        condOptions.appendChild(barColorGroup);
        condOptions.appendChild(paletteGroup);
        condOptions.appendChild(iconSetGroup);
        card.appendChild(condOptions);

        let updateCondVisibility = () => {
            let kind = condSelect.value;
            condOptions.style.display = (kind && kind !== 'none') ? 'grid' : 'none';
            [barColorGroup, paletteGroup, iconSetGroup].forEach(g => {
                g.style.display = (g.dataset.kind === kind) ? '' : 'none';
            });
        };
        condSelect.addEventListener('change', () => { updateCondVisibility(); this._fire(); });
        updateCondVisibility();

        this._bindDragReorder(card);

        this.listEl.appendChild(card);

        let $field = $(fieldInput);
        $field.kendoComboBox({
            dataTextField: this.fieldTextField,
            dataValueField: this.fieldValueField,
            filter: 'contains',
            syncValueAndText: false,
            value: col ? col.field : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.getFields(),
            change: (e) => {
                labelInput.value = GridColumnEditor.prettifyFieldName(e.sender.value());
                this._fire();
            }
        });

        card._fieldCombo = $field.data('kendoComboBox');
        card._labelInput = labelInput;
        card._widthInput = widthInput;
        card._alignSelect = alignSelect;
        card._formatSelect = formatSelect;
        card._condSelect = condSelect;
        card._totalsSelect = totalsSelect;
        card._condMinInput = minInput;
        card._condMaxInput = maxInput;
        card._barColorSelect = barColorSelect;
        card._paletteSelect = paletteSelect;
        card._iconSetSelect = iconSetSelect;

        this._fire();
    }

    _buildGroup(labelText) {
        let group = document.createElement('div');
        group.className = 'xp-grid-col-detail-group';
        let label = document.createElement('label');
        label.className = 'xp-grid-col-detail-label';
        label.textContent = labelText;
        group.appendChild(label);
        return group;
    }

    _buildSelect(className, entries) {
        let sel = document.createElement('select');
        sel.className = className + ' form-control';
        entries.forEach(([val, key]) => {
            let opt = document.createElement('option');
            opt.value = val;
            opt.textContent = this.getResource(key);
            sel.appendChild(opt);
        });
        return sel;
    }

    _bindDragReorder(card) {
        let list = this.listEl;
        card.addEventListener('dragstart', (e) => {
            card.classList.add('is-dragging');
            e.dataTransfer.effectAllowed = 'move';
            try { e.dataTransfer.setData('text/plain', ''); } catch (ex) { }
        });
        card.addEventListener('dragend', () => {
            card.classList.remove('is-dragging');
            list.querySelectorAll('.xp-grid-col-card.is-drop-target').forEach(el => el.classList.remove('is-drop-target'));
            this._fire();
        });
        card.addEventListener('dragover', (e) => {
            e.preventDefault();
            let dragged = list.querySelector('.xp-grid-col-card.is-dragging');
            if (!dragged || dragged === card) return;
            let rect = card.getBoundingClientRect();
            let after = (e.clientY - rect.top) > rect.height / 2;
            list.querySelectorAll('.xp-grid-col-card.is-drop-target').forEach(el => el.classList.remove('is-drop-target'));
            card.classList.add('is-drop-target');
            card.dataset.dropAfter = after ? '1' : '0';
        });
        card.addEventListener('drop', (e) => {
            e.preventDefault();
            let dragged = list.querySelector('.xp-grid-col-card.is-dragging');
            if (!dragged || dragged === card) return;
            let after = card.dataset.dropAfter === '1';
            if (after) card.after(dragged);
            else card.before(dragged);
            card.classList.remove('is-drop-target');
        });
    }

    _fire() {
        if (this.onChange) this.onChange();
    }

    static prettifyFieldName(name) {
        if (!name) return '';
        let s = String(name);
        let lower = s.toLowerCase();
        for (let p of PREFIX_STRIP) {
            if (lower.startsWith(p)) {
                s = s.substring(p.length);
                break;
            }
        }
        return s.split('_')
            .filter(p => p.length > 0)
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(' ');
    }

    static ensureStyles() {
        if (document.getElementById(STYLE_ID)) return;
        let style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent =
            '.xp-grid-col-card {' +
                'border:1px solid #e5e5e5;border-radius:6px;padding:8px;margin-bottom:8px;' +
                'background:#fff;transition:border-color 0.15s ease,box-shadow 0.15s ease,opacity 0.15s ease;' +
            '}' +
            '.xp-grid-col-card:hover {border-color:#ccc;}' +
            '.xp-grid-col-card.is-dragging {opacity:0.4;}' +
            '.xp-grid-col-card.is-drop-target {border-color:var(--theme-primary-700);box-shadow:0 0 0 2px rgba(var(--theme-primary-700-rgb, 0,0,0),0.15);}' +
            '.xp-grid-col-main {display:flex;align-items:center;gap:6px;}' +
            '.xp-grid-col-handle {' +
                'cursor:grab;color:#bbb;font-size:14px;line-height:1;padding:0 4px;user-select:none;' +
                'transition:color 0.15s ease;' +
            '}' +
            '.xp-grid-col-card:hover .xp-grid-col-handle {color:#777;}' +
            '.xp-grid-col-card.is-dragging .xp-grid-col-handle {cursor:grabbing;}' +
            '.xp-grid-col-field-wrap {flex:1;min-width:0;}' +
            '.xp-grid-col-label {flex:1;min-width:0;}' +
            '.xp-grid-col-remove {' +
                'width:24px;height:24px;border-radius:50%;border:1px solid #ddd;background:#fff;color:#999;' +
                'font-size:14px;line-height:1;cursor:pointer;padding:0;' +
                'transition:color 0.15s ease,border-color 0.15s ease;' +
            '}' +
            '.xp-grid-col-remove:hover {color:#d9534f;border-color:#d9534f;}' +
            '.xp-grid-col-detail {' +
                'display:grid;grid-template-columns:70px 1fr 1fr 1fr 1fr;gap:8px;margin-top:8px;padding-left:22px;' +
            '}' +
            '.xp-grid-col-detail-group {display:flex;flex-direction:column;}' +
            '.xp-grid-col-detail-label {' +
                'font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;' +
                'color:#888;margin:0 0 2px 0;' +
            '}' +
            '.xp-grid-col-width, .xp-grid-col-align, .xp-grid-col-format, .xp-grid-col-cond, .xp-grid-col-totals {' +
                'height:30px;padding:2px 6px;font-size:12px;' +
            '}' +
            '.xp-grid-col-cond-options {' +
                'display:none;grid-template-columns:1fr 1fr 2fr;gap:8px;' +
                'margin-top:8px;padding:8px 8px 6px 22px;' +
                'background:rgba(0,0,0,0.02);border-top:1px dashed #e5e5e5;border-radius:0 0 6px 6px;' +
            '}' +
            '.xp-grid-col-cond-min, .xp-grid-col-cond-max,' +
            '.xp-grid-col-barcolor, .xp-grid-col-palette, .xp-grid-col-iconset {' +
                'height:30px;padding:2px 6px;font-size:12px;' +
            '}';
        document.head.appendChild(style);
    }
}
